import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokhandalataxi() {



    const cardData = {

keyword: "Mumbai to Khandala Taxi Fare",

headingDescription:
    "Mumbai Airport Cab offers affordable, safe, and reliable Mumbai to Khandala Taxi Fare services for families, couples, corporate travelers, tourists, and weekend holidaymakers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional chauffeurs for a comfortable journey through the scenic Mumbai-Pune Expressway. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip taxi bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free travel experience to Khandala, one of Maharashtra's most beautiful hill stations known for its valleys, waterfalls, viewpoints, and pleasant weather throughout the year.",

topPlaces: [
    {
        title: "Rajmachi Point",
        description:
            "Rajmachi Point is one of the most visited attractions in Khandala, offering breathtaking views of the Rajmachi Fort, lush valleys, and surrounding mountain ranges. During the monsoon season, the landscape transforms into a green paradise with numerous waterfalls and mist-covered hills. Visitors enjoy photography, sightseeing, and peaceful moments while admiring the natural beauty that makes Khandala a favorite getaway from Mumbai."
    },
    {
        title: "Duke's Nose",
        description:
            "Duke's Nose is a famous cliff and viewpoint named after its resemblance to the Duke of Wellington's nose. The location offers spectacular panoramic views of the Western Ghats, deep valleys, and the Mumbai-Pune route below. Adventure enthusiasts visit for trekking, hiking, rock climbing, and photography, while nature lovers appreciate the dramatic scenery and refreshing atmosphere."
    },
    {
        title: "Tiger's Leap",
        description:
            "Tiger's Leap is a stunning viewpoint located near Khandala and Lonavala, known for its steep drop and panoramic valley views. The point resembles a tiger leaping into the valley, giving it its unique name. Visitors enjoy the cool mountain breeze, picturesque landscapes, and the mesmerizing sight of waterfalls during the rainy season."
    },
    {
        title: "Bhushi Dam",
        description:
            "Bhushi Dam is a popular attraction near Khandala that draws thousands of visitors during the monsoon months. The overflowing water steps create a fun and refreshing experience for families and groups. Surrounded by green hills and scenic landscapes, the dam provides excellent opportunities for relaxation, photography, and enjoying local snacks."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves dating back over two thousand years and are among the finest examples of early Indian rock-cut architecture. The grand prayer hall, intricate carvings, and historical significance attract tourists, pilgrims, and history enthusiasts from across the country. The elevated location also offers beautiful views of the surrounding hills."
    },
    {
        title: "Bhaja Caves",
        description:
            "Bhaja Caves are a remarkable collection of ancient Buddhist monuments featuring prayer halls, monasteries, and beautifully carved sculptures. Surrounded by green landscapes and seasonal waterfalls, the caves offer a peaceful and educational experience. Their historical importance and scenic setting make them a must-visit destination near Khandala."
    },
    {
        title: "Lohagad Fort",
        description:
            "Lohagad Fort is one of Maharashtra's most famous hill forts and is known for its strong fortifications, historic significance, and stunning views. The fort's famous Vinchu Kata formation and easy trekking route attract families, adventure seekers, and history lovers. During the monsoon season, the surrounding hills become exceptionally beautiful."
    },
    {
        title: "Kune Waterfalls",
        description:
            "Kune Waterfalls is one of the highest waterfalls in Maharashtra and is a major attraction near Khandala. Cascading from a significant height amidst dense greenery, the waterfall creates a spectacular natural setting. Visitors enjoy photography, sightseeing, and the refreshing atmosphere, especially during the rainy season."
    },
    {
        title: "Shooting Point",
        description:
            "Shooting Point is a scenic location famous for its panoramic views of valleys, hills, and forests. The area has been used for filming numerous movies and television productions due to its picturesque surroundings. Visitors enjoy relaxing walks, photography sessions, and peaceful moments amidst nature."
    },
    {
        title: "Amrutanjan Point",
        description:
            "Amrutanjan Point is one of the best viewpoints in Khandala, offering breathtaking views of the winding expressway, deep valleys, and surrounding mountains. The location is particularly beautiful during sunrise, sunset, and the monsoon season when clouds and mist cover the landscape. It is a perfect place to conclude a memorable Mumbai to Khandala taxi journey."
    }
],



services: [
{
name: "Mumbai to Khandala Taxi Fare",
description: "Mumbai Airport Cab offers affordable Mumbai to Khandala Taxi Fare with transparent pricing, professional drivers, and comfortable AC vehicles for safe and convenient travel. Whether you are planning a weekend getaway, family vacation, sightseeing tour, corporate outing, or romantic trip, we provide Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicle options. Our fare packages are designed to offer excellent value with no hidden charges, flexible pickup schedules, and reliable transportation from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and surrounding areas."
},
{
name: "Mumbai to Khandala Cab Fare",
description: "Get competitive Mumbai to Khandala Cab Fare with Mumbai Airport Cab. We offer budget-friendly and premium vehicle options, experienced chauffeurs, doorstep pickup, and customized travel plans for one way and round trip journeys."
},
{
name: "Mumbai to Khandala Taxi",
description: "Book Mumbai to Khandala Taxi with Mumbai Airport Cab for safe, comfortable, and hassle-free travel. Enjoy clean AC vehicles, courteous drivers, flexible pickup locations, and a relaxing drive through the scenic Mumbai–Pune Expressway route."
},
{
name: "Mumbai to Khandala Cab",
description: "Mumbai Airport Cab provides Mumbai to Khandala Cab service for families, couples, corporate travellers, and tourists. Our well-maintained fleet and experienced chauffeurs ensure a smooth and enjoyable hill station journey."
},
{
name: "Cab from Mumbai to Khandala",
description: "Choose a Cab from Mumbai to Khandala with Mumbai Airport Cab and enjoy reliable transportation, premium vehicle options, professional service, and comfortable travel throughout your journey."
},
{
name: "Mumbai to Khandala Car Rental",
description: "Book Mumbai to Khandala Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible travel, sightseeing tours, and customized holiday plans."
},
{
name: "Mumbai to Khandala One Way Taxi",
description: "Travel conveniently with Mumbai to Khandala One Way Taxi service featuring fixed rates, AC vehicles, experienced drivers, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Khandala Round Trip Taxi",
description: "Mumbai Airport Cab offers Mumbai to Khandala Round Trip Taxi packages for same-day returns, weekend vacations, sightseeing tours, and family outings with flexible travel schedules."
},
{
name: "Mumbai to Khandala Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Khandala Taxi Service with professional chauffeurs, comfortable vehicles, transparent pricing, and dependable transportation for all travel needs."
},
{
name: "Mumbai to Khandala Outstation Cab",
description: "Book Mumbai to Khandala Outstation Cab for comfortable long-distance travel with premium vehicles, affordable fares, and customized packages for leisure and business travellers."
},
{
name: "Mumbai to Khandala Hill Station Cab",
description: "Mumbai Airport Cab offers Mumbai to Khandala Hill Station Cab service with scenic travel routes, comfortable seating, experienced drivers, and convenient pickup options for a memorable trip."
},
{
name: "Mumbai Airport to Khandala Cab",
description: "Book Mumbai Airport to Khandala Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable AC vehicles for seamless airport transfers."
},
{
name: "Navi Mumbai to Khandala Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Khandala Cab service with doorstep pickup, affordable fares, premium vehicles, and reliable transportation for families and groups."
},
{
name: "Thane to Khandala Cab",
description: "Choose Thane to Khandala Cab with Mumbai Airport Cab for safe and comfortable travel with experienced chauffeurs, premium vehicles, and flexible travel schedules."
},
{
name: "Mumbai to Khandala Weekend Trip Cab",
description: "Book Mumbai to Khandala Weekend Trip Cab for relaxing short holidays with flexible pickup timings, comfortable vehicles, scenic hill station travel, and professional chauffeur service."
},
{
name: "Mumbai to Khandala Scenic Cab",
description: "Mumbai Airport Cab provides Mumbai to Khandala Scenic Cab service for travellers who want to enjoy beautiful mountain views, lush greenery, valleys, and the picturesque Mumbai–Pune Expressway route in complete comfort."
}
],

tableData: [
["Mumbai to Khandala Taxi Fare","Mumbai to Khandala Cab Fare"],
["Mumbai to Khandala Taxi","Mumbai to Khandala Cab"],
["Cab from Mumbai to Khandala","Mumbai to Khandala Car Rental"],
["Mumbai to Khandala One Way Taxi","Mumbai to Khandala Round Trip Taxi"],
["Mumbai to Khandala Taxi Service","Mumbai to Khandala Outstation Cab"],
["Mumbai to Khandala Hill Station Cab","Mumbai Airport to Khandala Cab"],
["Navi Mumbai to Khandala Cab","Thane to Khandala Cab"],
["Mumbai to Khandala Weekend Trip Cab","Mumbai to Khandala Scenic Cab"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Khandala Taxi Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Khandala Taxi services for families, tourists, couples, corporate travelers, and weekend vacationers seeking a comfortable journey."
},
{
WhyChooseheading: "Perfect Weekend Getaway Transportation",
WhyChoosedescription: "Khandala is one of the most popular hill destinations near Mumbai, attracting visitors with its scenic beauty, pleasant weather, and relaxing atmosphere."
},
{
WhyChooseheading: "Comfortable and Hassle-Free Travel",
WhyChoosedescription: "Our taxi service ensures a smooth travel experience with clean vehicles, experienced drivers, and convenient door-to-door transportation."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you need a one-way taxi, round trip package, same-day return, or customized sightseeing itinerary, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Professional Drivers and Safe Journey",
WhyChoosedescription: "Our trained drivers and regularly maintained vehicles ensure a safe, comfortable, and enjoyable journey to Khandala."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic vacations and family holidays to corporate outings and group tours, we offer suitable travel solutions for every traveler."
}
]
};

const faqData = [
{
question: "What is the Mumbai to Khandala Taxi Fare?",
answer: "Taxi fare depends on the vehicle type, travel duration, pickup location, and trip requirements. Contact Mumbai Airport Cabs for the latest fare details."
},
{
question: "Can I book a one-way taxi from Mumbai to Khandala?",
answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Khandala travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices for comfortable hill station travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return trips depending on their sightseeing plans and schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently choose Mumbai Airport Cabs for holidays, picnics, and weekend trips to Khandala."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and sightseeing tours."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can sightseeing places be included during the trip?",
answer: "Yes, customers can visit Rajmachi Point, Duke's Nose, Tiger's Leap, Bhushi Dam, and other nearby attractions."
},
{
question: "Is advance booking recommended?",
answer: "Yes, advance booking helps secure your preferred vehicle and ensures a smooth travel experience."
},
{
question: "How can I book a Mumbai to Khandala Taxi?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sagar More",
feedback:
"The taxi arrived exactly on schedule and the entire journey to Khandala was comfortable. The driver was polite and familiar with all major routes.",
rating: 5
},
{
id: 2,
name: "Mrs. Priti Shah",
feedback:
"Mumbai Airport Cabs made our Khandala weekend getaway completely stress-free. The vehicle was clean, spacious, and the service exceeded our expectations.",
rating: 5
}
];



































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Khandala Taxi Fare",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-khandala-cab.jpg",
"description": "Book Mumbai to Khandala taxi service for a quick and scenic hill station trip. Mumbai Airport Cabs offers reliable cab service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options for Khandala travel.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-khandala-taxi-fare"
}
};










    return (
        <div>

<Helmet>
  <title>Mumbai to Khandala Taxi Fare | Cab Service | +91 9545731161</title>

<meta
 name="description"
 content="Check Mumbai to Khandala taxi fare and book reliable cab service. Affordable one-way and round-trip taxi options with professional drivers and comfortable cars for Khandala hill station travel."
/>

<meta
 name="keywords"
 content="mumbai to khandala taxi fare, mumbai to khandala cab fare, mumbai to khandala taxi, mumbai to khandala cab, cab from mumbai to khandala, mumbai to khandala car rental, mumbai to khandala one way taxi, mumbai to khandala round trip taxi, khandala taxi from mumbai, khandala cab booking mumbai, hill station cab mumbai to khandala, outstation taxi mumbai to khandala, best cab service mumbai to khandala"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokhandalataxi;